import { render, staticRenderFns } from "./LaserbeamerView.vue?vue&type=template&id=5db44a16&scoped=true"
import script from "./LaserbeamerView.vue?vue&type=script&lang=js"
export * from "./LaserbeamerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db44a16",
  null
  
)

export default component.exports